import { useUI } from "providers/UIProvider"

import { Box, Flex } from "@chakra-ui/react"
import Input from "components/UI/atoms/Input"
import Select from "components/UI/atoms/Select"
import { ILaundryServicesTimeAndPriceProps } from "./LaundryServicesTypes"

const LaundryServicesTimeAndPrice: React.FC<
  ILaundryServicesTimeAndPriceProps
> = ({
  priceValue,
  priceOnChange,
  priceHandleChange,
  timeValue,
  timeOnchange,
  priceName,
  timeName,
  onBlur,
  error
}) => {
    const { T } = useUI()

    return (
      <Flex gap={"14px"} justifyContent={"center"} alignItems={"center"}>
        <Box width={"80px"} height={"50px"}>
          <Input
            id="idNumber"
            name={priceName}
            type="number"
            styles={{ height: "50px", width: "80px" }}
            value={priceValue}
            onChange={(e: any) => {
              priceOnChange(e);
              priceHandleChange(e);
            }}
            onBlur={onBlur}
            error={error}
          />
        </Box>
        <Box width={"80px"} height={"50px"}>
          <Select
            onBlur={onBlur}
            error={error}
            placeholder={T("loundry.time")}
            inputStyles={{ width: "80px", height: "50px" }}
            onChange={timeOnchange}
            value={timeValue}
            options={[
              { label: "10", value: 10 },
              { label: "20", value: 20 },
              { label: "30", value: 30 },
              { label: "40", value: 40 },
              { label: "50", value: 50 },
              { label: "60", value: 60 },
              { label: "70", value: 70 },
              { label: "80", value: 80 },
              { label: "90", value: 90 },
              { label: "100", value: 100 },
              { label: "110", value: 110 },
              { label: "120", value: 120 },
            ]}
          />
        </Box>
      </Flex>
    )
  }
export default LaundryServicesTimeAndPrice